module.exports = __webpack_public_path__ + "static/media/Menu-12.8b6c882c.jpg";